import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { Button, Drawer, Form, Tooltip } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";

import useModel from "../../stores/model";

import AttributeTextForm from "./AttributeTextForm";

import useDrawer from "../../hooks/useDrawer";

const { useForm } = Form;

const CreateText = ({
  defaultDrawerVisible = false,
  attrListActiveId,
  nowId,
  rowIndex
}: {
  defaultDrawerVisible?: boolean;
  attrListActiveId?: any;
  nowId?: any;
  rowIndex: number
}) => {
  const [form] = useForm();

  const [first, setFirst] = useState(true);

  const { appendSubAttribute } = useModel();

  const submitHook = () => {
    const values = form.getFieldsValue();
    const { name, order } = values;
    const newAttribute = {
      order,
      name: [
        { value: name.zh, lang: "0" },
        { value: name.en, lang: "1" },
        { value: name.ru, lang: "2" },
      ],
      src: 0,
      path: "",
    };

    appendSubAttribute(rowIndex, newAttribute);
  };

  const {
    visible,
    show,
    hide,
    onSubmit
  } = useDrawer(submitHook);

  const { t } = useTranslation();

  useEffect(() => {
    if (first && defaultDrawerVisible && attrListActiveId && nowId) {

      if (nowId === Number(attrListActiveId)) {
        show();
  
        setFirst(false);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultDrawerVisible, attrListActiveId, nowId]);

  return (
    <>
      <Tooltip title={t("model.addTextAtt.button")}>
        <Button type="text" icon={<PlusCircleOutlined />} onClick={show} />
      </Tooltip>
      <Drawer
        title={t("model.addTextAtt.title")}
        visible={visible}
        onClose={hide}
        destroyOnClose
        extra={
          <Button type="primary" onClick={onSubmit}>
            {t("model.addTextAtt.submit")}
          </Button>
        }
      >
        <AttributeTextForm form={form} />
      </Drawer>
    </>
  );
};

export default CreateText;
